import React from 'react';

//Composants
import Title from '../../components/Title/Title';
import ContentText from '../../components/content/content-text.jsx';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider';
import Skills from '../../components/Projects/Skills.jsx';

//Contenus
import cheerleading from '../../assets/content/projets/cheerleading.json';


const Cheerleading = () => {

    return (
        <div className='projet'>
            <div class="bloc">
                <Title title={cheerleading.title} variant={cheerleading.variant} />
                <ContentText content={cheerleading.description} />


                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    <ContentSlider content={cheerleading.partie1} images={cheerleading.slider1} cote={"left"}></ContentSlider>   
                    <ContentSlider content={cheerleading.partie2} images={cheerleading.slider2} cote={"right"}></ContentSlider>

                    <Content content={cheerleading.partie3} image={{thumb: cheerleading.imgpartie3,hd: cheerleading.imgpartie3grd}} alt={cheerleading.altpartie3} cote={"left"}></Content>
                    <div className='content-text'>
                        <ContentText content={cheerleading.partie4} />
                    </div>

                   
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {cheerleading.technologies.map((tech, index) => (
                    <Skills
                        image={tech.image}
                        alt={tech.alt}
                        competence={tech.name}
                        centered={tech.bool}
                    />
                ))}
                </div>
            </div>
            <div className='competences bloc'>
                <SimpleTitle title="Compétences et apprentissages critiques mobilisés" variant="purple" position="left" />
                <Content content={cheerleading.competences} image={{thumb: cheerleading.imgcompetences,hd: cheerleading.imgcompetencesgrd}} alt={cheerleading.altcompetencesgrd} cote={"left"} width={cheerleading.widthcompetences} height={cheerleading.heightcompetences} title="Illustration des compétences"></Content>
            </div>
            
        </div>
    );
};

export default Cheerleading;